var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.appliedDiscounts.length > 0,
          expression: "appliedDiscounts.length>0",
        },
      ],
    },
    [
      _c("div", { staticClass: "discount-summary" }, [
        _c("div", { staticClass: "discount-summary__table" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "discount-summary__body" },
            _vm._l(_vm.appliedDiscounts, function (entry, index) {
              return _c(
                "div",
                { key: index, staticClass: "discount-summary__row" },
                [
                  _c("div", { staticClass: "discount-summary__cell left" }, [
                    _vm._v(_vm._s(entry.itemName)),
                  ]),
                  _c("div", { staticClass: "discount-summary__cell left" }, [
                    _vm._v(_vm._s(entry.discountName)),
                  ]),
                  _c("div", { staticClass: "discount-summary__cell" }, [
                    _vm._v(" " + _vm._s(entry.percentage) + "% "),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "discount-summary__cell right discount-summary__cell--highlight",
                    },
                    [
                      _vm._v(
                        " -" + _vm._s(entry.absoluteAmount.toFixed(2)) + "€ "
                      ),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ]),
        _vm.appliedDiscounts.length === 0
          ? _c("div", { staticClass: "discount-summary__empty" }, [
              _vm._v(" Keine Rabatte angewendet. "),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "discount-summary__head" }, [
      _c("div", { staticClass: "discount-summary__header-cell left" }, [
        _vm._v("Artikel"),
      ]),
      _c("div", { staticClass: "discount-summary__header-cell left" }, [
        _vm._v("Rabatt"),
      ]),
      _c(
        "div",
        {
          staticClass:
            "discount-summary__header-cell discount-summary__header-cell",
        },
        [_vm._v("%")]
      ),
      _c("div", { staticClass: "discount-summary__header-cell right" }, [
        _vm._v("Ersparnis"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }